'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _imageModal = require('./image-modal');

var _imageModal2 = _interopRequireDefault(_imageModal);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ImageModalTrigger = _react2['default'].createClass({
    displayName: 'ImageModalTrigger',


    propTypes: {
        'imagePath': _react2['default'].PropTypes.string,
        'classNames': _react2['default'].PropTypes.string
    },

    handleClick: function handleClick(e) {
        if (e != null) {
            e.preventDefault();
        }
        var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('image_modal', 'small', true, 'l-margin-t--80 text-center');
        _reactDom2['default'].unmountComponentAtNode(attachPoint);
        _reactDom2['default'].render(_react2['default'].createElement(_imageModal2['default'], { imagePath: this.props.imagePath }), attachPoint);
    },
    render: function render() {
        return _react2['default'].createElement(
            'span',
            { onClick: this.handleClick },
            _react2['default'].createElement('img', { src: this.props.imagePath, className: this.props.classNames, style: { cursor: 'pointer' } })
        );
    }
});

module.exports = ImageModalTrigger;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/image-modal-trigger.jsx
 ** module id = 870
 ** module chunks = 0
 **/